import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { T } from "@/components/T";

const prozessSchritte = {
  de: [
    { nr: "01", titel: "Erstgespräch & Analyse", text: "Wir beurteilen Ihr Vorhaben, die Machbarkeit und die Substanz. Ehrlich und kompetent – ohne Verpflichtung." },
    { nr: "02", titel: "Konzept & 3D-Planung", text: "Klare Visualisierung. Grundrisse, Ansichten, Schnitte. Und ein realistischer Kostenrahmen." },
    { nr: "03", titel: "Vorfertigung im Werk", text: "Alle Elemente werden präzise vorgefertigt. Millimetergenau, witterungsunabhängig, qualitätskontrolliert." },
    { nr: "04", titel: "Montage & Ausführung", text: "Kurze, saubere Montagezeit auf der Baustelle. In der Regel wenige Tage – nicht Monate." },
    { nr: "05", titel: "Übergabe & Dokumentation", text: "Das Holzbuddy Team übergibt vollständig – mit Dokumentation und Pflegeempfehlungen. Kein offenes Ende." },
  ],
  it: [
    { nr: "01", titel: "Prima consulenza & analisi", text: "Valutiamo il vostro progetto, la fattibilità e la struttura. Onestamente e con competenza – senza impegno." },
    { nr: "02", titel: "Concetto & Pianificazione 3D", text: "Visualizzazione chiara. Planimetrie, prospetti, sezioni. E un preventivo realistico dei costi." },
    { nr: "03", titel: "Prefabbricazione in officina", text: "Tutti gli elementi vengono prefabbricati con precisione. Al millimetro, indipendentemente dalle condizioni meteo, con controllo qualità." },
    { nr: "04", titel: "Montaggio & Esecuzione", text: "Breve e pulito tempo di montaggio in cantiere. Di solito pochi giorni – non mesi." },
    { nr: "05", titel: "Consegna & Documentazione", text: "Il team Holzbuddy consegna completamente – con documentazione e raccomandazioni per la cura. Nessuna questione aperta." },
  ],
};

export function ProzessSection() {
  const { lang } = useLanguage();
  const schritte = prozessSchritte[lang];

  return (
    <section data-testid="prozess-section" className="section-gap" style={{ background: "#111318" }}>
      <div className="container-hb">
        <span className="label-text block mb-4 reveal" style={{ color: "rgba(245,200,0,0.5)" }}>
          <T de="Ablauf" it="Procedura" />
        </span>
        <h2 className="font-bebas text-white mb-16 reveal reveal-delay-1" style={{ fontSize: "clamp(48px, 6.5vw, 88px)", lineHeight: 1 }}>
          <T de="So arbeiten wir." it="Come lavoriamo." />
        </h2>
        <div className="border-t" style={{ borderColor: "rgba(255,255,255,0.08)" }}>
          {schritte.map((s, i) => (
            <div key={s.nr} data-testid={`prozess-${s.nr}`}
              className={`group flex gap-6 md:gap-10 py-7 border-b reveal reveal-delay-${(i % 3) + 1}`}
              style={{ borderColor: "rgba(255,255,255,0.08)" }}>
              <span className="font-cormorant font-light flex-shrink-0 leading-none group-hover:text-hb-yellow transition-colors duration-500"
                style={{ fontSize: "clamp(52px, 7vw, 88px)", lineHeight: 1, minWidth: "80px", textAlign: "right", color: "rgba(245,200,0,0.10)" }}>
                {s.nr}
              </span>
              <div className="pt-3">
                <h3 className="font-manrope font-bold text-white text-sm md:text-base mb-2">{s.titel}</h3>
                <p className="text-sm font-inter leading-relaxed max-w-md" style={{ color: "rgba(255,255,255,0.42)" }}>{s.text}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col sm:flex-row gap-4 reveal">
          <Link to="/anfrage" data-testid="prozess-cta-btn" className="btn-primary">
            <T de="Erstgespräch anfragen" it="Richiedi una prima consulenza" />
          </Link>
          <a href="tel:+390473238030" data-testid="prozess-phone-btn"
            className="text-xs tracking-widest uppercase font-semibold px-8 py-4 transition-all duration-300 font-inter inline-flex items-center gap-2"
            style={{ border: "1px solid rgba(245,200,0,0.25)", color: "rgba(255,255,255,0.55)" }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(245,200,0,0.6)"; e.currentTarget.style.color = "#f5c800"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(245,200,0,0.25)"; e.currentTarget.style.color = "rgba(255,255,255,0.55)"; }}>
            <Phone size={12} /> +39 0473 238 030
          </a>
        </div>
      </div>
    </section>
  );
}
